import { Model } from 'modules/core/lib/mobx-rest'

interface ILeave {
  id: number
  approved: boolean
  employee_id: number
  finish_on?: string
  half_day?: string
  hourly: boolean
  hours_amount?: number
  start_on: string
  start_time?: string
  type_color: string
  type_name: string
  type_workable: boolean
  description: string
}

class Leave extends Model<ILeave> {
  static urlRoot() {
    return '/shift_management/leaves'
  }
}

export default Leave
